import { Breadcrumb, Breadcrumbs } from 'common/types/entities/api/window'
import { fetchBranchBreadcrumbs, fetchStoreBreadcrumbs } from 'common/services/breadcrumb'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'
import { StateKey } from 'common/utils/flipState'
import { BreadCrumbParam } from 'common/types/params/breadcrumb'
import { getSubVerticalPath, SpecialEventType, SubVertical, Vertical } from 'common/constants'
import { defaultBreadcrumbs } from 'common/utils/breadcrumbs'
import { getEventTitle } from 'common/constants/event'

const initialState: Breadcrumbs = {
  cacheParam: null,
  breadcrumbs: null,
}

const FETCH = '/breadcrumb/FETCH'

export const getStoreBreadcrumbs = (curState: StateKey, storeId: string) => async (dispatch, getState) => {
  const cacheParam = createCacheParam(FETCH, 'getStoreBreadcrumbs', { curState, storeId })
  if (isCacheHit(getState().breadcrumbs[curState], cacheParam)) {
    return
  }

  const result = await fetchStoreBreadcrumbs(storeId)
  dispatch({
    curState,
    cacheParam,
    breadcrumbs: result,
    type: FETCH,
  })
}

export const getBranchBreadcrumbs = (curState: StateKey, params: BreadCrumbParam) => async (dispatch, getState) => {
  const cacheParam = createCacheParam(FETCH, 'getBranchBreadcrumbs', { curState, params })
  if (isCacheHit(getState().breadcrumbs[curState], cacheParam)) {
    return
  }

  const result = await fetchBranchBreadcrumbs(params)
  dispatch({
    curState,
    cacheParam,
    breadcrumbs: result,
    type: FETCH,
  })
}

export const getSpecialEventBreadcrumbs = (
  curState: StateKey,
  vertical: Vertical,
  subVertical: SubVertical,
  specialEventType?: SpecialEventType,
) => async (dispatch, getState) => {
  const cacheParam = createCacheParam(FETCH, 'getSpecialEventBreadcrumbs', {
    curState,
    vertical,
    subVertical,
    specialEventType,
  })
  if (isCacheHit(getState().breadcrumbs[curState], cacheParam)) {
    return
  }

  const breadcrumbs: Breadcrumb[] = defaultBreadcrumbs(vertical, subVertical)
  breadcrumbs.push({
    text: getEventTitle(subVertical, specialEventType),
    urlPc: specialEventType
      ? `${getSubVerticalPath(subVertical)}/event?eventType=${specialEventType.toLowerCase()}`
      : `${getSubVerticalPath(subVertical)}/event`,
  })

  dispatch({
    curState,
    cacheParam,
    vertical,
    subVertical,
    breadcrumbs,
    type: FETCH,
  })
}

export const getAiTemsBreadcrumbs = (curState: StateKey, vertical: Vertical, subVertical: SubVertical) => async (
  dispatch,
  getState,
) => {
  const cacheParam = createCacheParam(FETCH, 'getAiTemsBreadcrumbs', {
    curState,
    vertical,
    subVertical,
  })
  if (isCacheHit(getState().breadcrumbs[curState], cacheParam)) {
    return
  }

  const breadcrumbs: Breadcrumb[] = defaultBreadcrumbs(vertical, subVertical)
  breadcrumbs.push({
    text: 'AiTems',
    urlPc: '',
  })

  dispatch({
    curState,
    cacheParam,
    vertical,
    subVertical,
    breadcrumbs,
    type: FETCH,
  })
}

const breadcrumbReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        cacheParam: action.cacheParam,
        breadcrumbs: action.breadcrumbs,
      }
    default:
      return state
  }
}

export default breadcrumbReducer
